import { Text } from '#app/components/Primitives/Text.js';
import TextareaAutosize from 'react-textarea-autosize';
import { css, styled } from 'styled-components';

export const Textarea = styled(TextareaAutosize)`
  ${({ theme }) => css`
    width: 100%;
    border: none;
    background: transparent;
    resize: none;
    padding: 12px;
    line-height: ${theme.textStyles.bodyRegular.lineHeight};
  `}
`;

export const EditableActions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  width: 100%;
`;

export const ValidationRow = styled.div<{ textAlign?: 'center' | 'left' }>`
  ${({ textAlign = 'left' }) => css`
    padding: 4px 0 16px 0;
    display: flex;
    align-items: center;
    justify-content: ${textAlign === 'left' ? 'space-between' : 'center'};
    text-align: ${textAlign};
  `}
`;

export const ValidationText = styled(Text)<{ hasError?: boolean }>`
  ${({ hasError = false, theme }) => css`
    color: ${hasError ? theme.colorsV2.red50 : theme.colorsV2.gray60};
    font-size: 12px;
  `}
`;
